import React, { useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { PHRASE_QUESTIONS_FOR_ME_QUERY, ANSWER_PHRASE_QUESTION_MUTATION } from '../query/gqlQueries'

// A student's questions about sentences they were practising, for their
// teacher: the sentence, what they asked, and a box to answer. The answer
// reaches them as a teacher's note, where they already look.
const when = (v) => { const t = v ? new Date(v) : null; return t && !isNaN(t) ? t.toLocaleDateString(undefined, { day: 'numeric', month: 'short' }) : '' }

export default function PhraseQuestions({ student, lang, styles }) {
  const q = useQuery(PHRASE_QUESTIONS_FOR_ME_QUERY, { variables: { limit: 100 }, fetchPolicy: 'cache-and-network', errorPolicy: 'ignore' })
  const list = (q.data?.phraseQuestionsForMe || []).filter(x => x.student === student && (!lang || x.lang === lang))
  if (!list.length) return null
  const open = list.filter(x => !x.reviewedAt).length
  return (
    <section className={styles.card}>
      <div className={styles.cardHead}>
        <span className={styles.cardLabel}>Their questions</span>
        <span className={styles.cardNote}>{open ? `${open} waiting for you` : 'all answered'}</span>
      </div>
      {list.map(x => <Question key={x.id} x={x} styles={styles} />)}
    </section>
  )
}

function Question({ x, styles }) {
  const [draft, setDraft] = useState('')
  const [answer, { loading }] = useMutation(ANSWER_PHRASE_QUESTION_MUTATION, { refetchQueries: [PHRASE_QUESTIONS_FOR_ME_QUERY] })
  const [err, setErr] = useState('')
  const send = async () => {
    setErr('')
    try { await answer({ variables: { id: x.id, comment: draft.trim() } }); setDraft('') } catch (e) { setErr(e.message || 'That didn’t send.') }
  }
  return (
    <div className={styles.weakRow} style={{ flexDirection: 'column', alignItems: 'stretch', gap: '0.45rem' }}>
      <div>
        <div className={styles.weakTerm}>{x.text}</div>
        {x.meaning && <div className={styles.weakTrans}>{x.meaning}</div>}
      </div>
      <div style={{ fontSize: '0.92rem' }}>{x.question ? `“${x.question}”` : 'Asked about this sentence.'} <span className={styles.cardNote}>{when(x.askedAt)}</span></div>
      {x.reviewedAt ? (
        <div className={styles.msg}>You answered: {x.comment}</div>
      ) : (
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
          <textarea value={draft} onChange={e => setDraft(e.target.value)} rows={2} placeholder="Your answer — they'll get it as a note"
            style={{ flex: 1, minHeight: 'auto', font: 'inherit', padding: '0.55rem 0.7rem', color: 'inherit' }} />
          <button className={styles.primaryBtn} onClick={send} disabled={!draft.trim() || loading}>{loading ? 'Sending…' : 'Answer'}</button>
        </div>
      )}
      {err && <div className={styles.err}>{err}</div>}
    </div>
  )
}
